import { getInitialBadgeColor } from '@/lib/utils/color.utils';
import { getInitials } from '@/lib/utils/name.utils';

export interface InitialsBadgeProps {
  name: string;
  badgeClassName?: string;
}

export function InitialsBadge({ name, badgeClassName }: InitialsBadgeProps) {
  const badgeColor = getInitialBadgeColor(name) + ' ' + (badgeClassName || '');
  const initials = getInitials(name);
  return (
    <span
      className={`flex h-6 w-6 items-center justify-center rounded-md text-small text-slate-50 ${badgeColor}`}
    >
      {initials}
    </span>
  );
}

